// extracted by mini-css-extract-plugin
export default {"base":"CommentShow_base__XG0j3"};